/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useEffect, useMemo } from "react";
import type { RumPublicApi } from "@datadog/browser-rum-core";
import { logger } from "~/services/datadog/logger";
import { getGlobalObject } from "./utils/getGlobalObject";

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    DD_RUM?: RumPublicApi;
  }
}

const NODE_ENV = String(process.env.NODE_ENV ?? "unknown") as
  | "development"
  | "production"
  | "unknown";

const isNotLocalServer = NODE_ENV === "production";

export function useDatadogRUM(): RumPublicApi | undefined {
  useEffect(() => {
    if (isNotLocalServer && getGlobalObject<Window>().DD_RUM == null) {
      logger?.error("Datadog RUM not available");
    }
  }, []);

  return useMemo(() => getGlobalObject<Window>().DD_RUM, []);
}
